module.exports = __webpack_public_path__ + "static/media/support6.d83277d6.png";